import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from './EventDetailPage.module.css';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

function EventDetailPage() {
    const { eventId } = useParams();
    const [event, setEvent] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`${API_URL}/api/events/${eventId}`)
            .then(res => setEvent(res.data))
            .catch(console.error);
    }, [eventId]);

    if (!event) return <div>로딩 중.</div>;

    return (
        <div className={styles.container}>
            {event.thumbnailUrl && (
                <img src={`${API_URL}${event.thumbnailUrl}`}
                    alt={event.title} className={styles.thumbnail} />
            )}
            <h2 className={styles.title}>{event.title}</h2>
            {event.startDate && event.endDate && (
                <p className={styles.period}>
                    {new Date(event.startDate).toLocaleDateString()} ~ {new Date(event.endDate).toLocaleDateString()}
                </p>
            )}
            <div className={styles.content}
                dangerouslySetInnerHTML={{ __html: event.content }} />
            <button onClick={() => navigate('/events')} className={styles.backBtn}>목록</button>
        </div>
    );
}

export default EventDetailPage;